export default {
  methods: {
    _levelDeg: function(x1, y1, cx, cy) {
      var dx = x1 - cx,
          dy = y1 - cy,
          deg = 360 * Math.atan2(dy, dx) / (2 * Math.PI);
      if(dx > 0 && dy == 0) {
        // x轴正方向上
        deg = 0;
      } else if(dx < 0 && dy == 0) {
        // x轴负方向
        deg = 180;
      } else if( dy > 0 && dx == 0) {
        // y轴正方向
        deg = 90;
      }else if(dy < 0 && dx == 0) {
        // y轴负方向
        deg = 270;
      }else if(dx != 0 && dy < 0) {
        deg = 360 + deg;
      }

      return deg;
    },
    _changeLength: function(x1, y1, x2, y2, x3, y3) {
      // 计算元素宽高应该增加为多少？(x3, y3)为元素的中心点
      return this._len(x1, y1, x3, y3) * Math.cos(this._angle(x1, y1, x2, y2, x3, y3) * Math.PI / 180) - this._len(x2, y2, x3, y3);
    },
    _scaleSize: function(x1, y1, x2, y2, x3, y3) {
      // 计算斜对角放大的倍数(参数参考 _angle函数参数)
      var len = this._changeLength(x1, y1, x2, y2, x3, y3);

      return (1 + len / this._len(x2, y2, x3, y3) / 2);
    },
    _len: function(x1, y1, x2, y2) {
      // 计算点点之间的距离
      return Math.sqrt((x1 - x2) * (x1 - x2) + (y1 - y2) * (y1 - y2));
    },
    _rotSize: function(newWidth, newHeight, oldWidth, oldHeight, left, top, angle, type) {
      // 固定四个点不动的方法
      var angle = angle * Math.PI / 180,
          centerTop = top + oldHeight / 2,
          centerLeft = left + oldWidth / 2,
          x,
          y,
          newTop,
          newLeft;

      switch (type) {
        case 'top-left':
            // 上左不动
            x = -oldWidth / 2;
            y = oldHeight / 2;
            break;
        case 'top-right':
            x = oldWidth / 2;
            y = oldHeight / 2;
            break;
        case 'bottom-left':
            x = -oldWidth / 2;
            y = -oldHeight / 2;
            break;
        case 'bottom-right':
            x = oldWidth / 2;
            y = -oldHeight / 2;
            break;
      }

      newLeft = x * Math.cos(angle) + y * Math.sin(angle) + centerLeft;
      newTop = x * Math.sin(angle) - y * Math.cos(angle) + centerTop;

      switch (type) {
        case 'top-left':
            // 上左不动
            newTop = newWidth / 2 * Math.sin(angle) + newHeight / 2 * Math.cos(angle) - newHeight / 2 + newTop;
            newLeft = newWidth / 2 * Math.cos(angle) - newHeight / 2 * Math.sin(angle) - newWidth / 2 + newLeft;
            break;
        case 'top-right':
            newTop = -newWidth / 2 * Math.sin(angle) + newHeight / 2 * Math.cos(angle) - newHeight / 2 + newTop;
            newLeft = -newWidth / 2 * Math.cos(angle) - newHeight / 2 * Math.sin(angle) - newWidth / 2 + newLeft;
            break;
        case 'bottom-left':
            newTop = newWidth / 2 * Math.sin(angle) - newHeight / 2 * Math.cos(angle) - newHeight / 2 + newTop;
            newLeft = newWidth / 2 * Math.cos(angle) + newHeight / 2 * Math.sin(angle) - newWidth / 2 + newLeft;
            break;
        case 'bottom-right':
            newTop = -newWidth / 2 * Math.sin(angle) - newHeight / 2 * Math.cos(angle) - newHeight / 2 + newTop;
            newLeft = -newWidth / 2 * Math.cos(angle) + newHeight / 2 * Math.sin(angle) - newWidth / 2 + newLeft;
            break;
      }

      return { top: newTop, left: newLeft };
    },
    _angle: function(x1, y1, x2, y2, x3, y3) {
      // 求以(x3，y3)为顶点的角度
      var deg = this._levelDeg(x1, y1, x3, y3) - this._levelDeg(x2, y2, x3, y3);
      if(deg < 0) {
        deg = 360 + deg;
      }
      return deg;
    },
    _rotateWithPoint: function(a, o, deg) {
      //点a围绕o点旋转deg(顺时针)角度后的位置
      var b = {};

      deg = Math.PI/180 * deg;
      b.x = ( a.x - o.x ) * Math.cos(deg) - ( a.y - o.y ) * Math.sin(deg) + o.x;
      b.y = ( a.x - o.x ) * Math.sin(deg) + ( a.y - o.y ) * Math.cos(deg) + o.y;

      return b
    },
    _rotateLinePoint: function(a, len, deg) {
      // 点a是点b由向x轴正方向延伸距离len的点c,然后绕点c旋转deg角度后的，此处求点b
      var b = {};

      deg = -Math.PI/180 * deg || 0;
      b.x = a.x - len * (1 - Math.cos(deg));
      b.y = a.y - len * Math.sin(deg);

      return b
    },
    _getLine: function(a, deg) {
      // 已知与 *y轴* 夹角deg,和直线上一点a,求直线ax + by + c = 0的a, b, c
      if(deg!==0 && (deg % 180) && !(deg % 90)) {
        return {
          a: 0,
          b: 1,
          c: -a.x
        }
      }
      deg = Math.PI/180 * deg;
      return {
        a: 1,
        b: -Math.tan(deg),
        c: Math.tan(deg) * a.y - a.x
      }
    },
    _getFlipPoint(line, p) {
      // 已知直线line和点p,求p已直线line镜像后的点位置
      let temp = -2 * (line.a * p.x + line.b * p.y + line.c) / (line.a * line.a + line.b * line.b);
      return {
        x: temp * line.a + p.x,
        y: temp * line.b + p.y
      }
    },
    _angelT: function(x1, y1, x2, y2) {
      return Math.atan2(y2-y1, x2-x1)*180/Math.PI
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/mixins/forDragFn.js